import React from 'react';
import Loadable, { LoadingComponentProps } from 'react-loadable';

const Loading: React.FC<LoadingComponentProps> = (props) => {
  if (props.error) {
    return <p>Error!</p>;
  } else if (props.pastDelay) {
    return <p>loading...</p>;
  } else {
    return null;
  }
};

export default function loadablePage(page: string) {
  return Loadable({
    loader: () => import(`@/pages/${page}`),
    loading: Loading,
  });
}
